import "./MainBlog.scss";
import CardBlog from "./CardBlog";
import {useEffect, useState, useMemo} from "react";
import axios from "axios";
import Pagination from "../Pagination/Pagination";
import Title from "../Title/Title";
import {prefixUrl} from "../../Utils/utilsData";
import Loader from "../Loader/Loader";

const AllBlogs = () => {
  const [blogPosts, setBlogPosts] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isLoad, setIsLoad] = useState(false)
  let PageSize = 9;

  const currentPageData = useMemo(() => {
    const firstPageIndex = (currentPage - 1) * PageSize;
    const lastPageIndex = firstPageIndex + PageSize;
    return blogPosts.slice(firstPageIndex, lastPageIndex);
  }, [currentPage, PageSize, blogPosts]);

  useEffect(() => {
    axios.get(`${prefixUrl()}/blog/getAll.php`).then((res) => {
      if (res.data.status) {
        setBlogPosts(res.data.output);
        setIsLoad(true)
      }
    });
  }, []);

  return (
    <div className="cardsBlogsPrnt__">
      {isLoad ?
        <>
          <Title title={"بلاگ"} englishTitle={""}/>
          {currentPageData.map((v, index) => {
            return <CardBlog blogData={v} key={index}/>;
          })}

          <Pagination
            key={59955}
            className="pagination-bar"
            currentPage={currentPage}
            totalCount={blogPosts.length}
            pageSize={PageSize}
            onPageChange={(page) => setCurrentPage(page)}
          />
        </>
        : <Loader/>}
    </div>
  );
};

export default AllBlogs;
